import { memo } from 'react';
import clsx from 'clsx';
import { ProductImage } from 'src/modules/common/components/ProductImage/ProductImage.tsx';
import { RenderHtml } from 'src/common/RenderHtml/RenderHtml';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';

type Props = {
    title: string;
    imgAlt: string;
    checked: boolean;
    disabled: boolean;
    onChange: () => void;
    imageURL: string;
    isSingleChoice: boolean;
}

export const HomeActuator = memo(({
    title,
    checked,
    disabled,
    onChange,
    imageURL,
    imgAlt,
    isSingleChoice,
}: Props) => (
    <button
        type="button"
        className={clsx({
            'vss-home-actuator': true,
            'vss-home-actuator--disabled': disabled,
        })}
        onClick={disabled ? () => null : onChange}
    >
        <div className="vss-home-actuator__header">
            <RenderHtml data={title} className="vss-home-actuator__title"/>

            {!isSingleChoice && (
                <div className={clsx({
                    'vss-home-actuator__checkbox': true,
                    'vss-home-actuator__checkbox--checked': checked,
                })}
                />
            )}
        </div>

        <div className="vss-home-actuator__image">
            <ProductImage imgSrc={imageURL} imgAlt={imgAlt}/>
        </div>

        {isSingleChoice && (
            <div className="vss-home-actuator__actions">
                <div className="vss-home-actuator__icon">
                    <ArrowRightIcon/>
                </div>
            </div>
        )}
    </button>
));
